import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { PhoneIcon24, LocationIcon24, LocationIcon, EmailIcon, PhoneIcon, GlobeIcon } from './SVGIcons';

class First extends Component {
  static defaultProps = {

  }

  state = {

  }

  componentDidMount() {
    this.setState({
      isClient: true
    });
  }

  // Функция для парсинга координат
  parseCoords = (coordsString) => {
    if (!coordsString) return null;
    const [lat, lng] = coordsString.split(',').map(coord => parseFloat(coord.trim()));
    return [lat, lng];
  }

  // Компонент для отображения карты
  renderMap = (coords, height = '125px', mapId = 'footer-map') => {
    const { isClient, mapsError } = this.state;
    
    if (!isClient) {
      return this.renderMapPlaceholder(height);
    }

    if (mapsError) {
      return this.renderMapPlaceholder(height, 'Ошибка загрузки карты');
    }

    if (!coords) {
      return this.renderMapPlaceholder(height, 'Координаты не указаны');
    }

    if (typeof window !== 'undefined' && window.ymaps) {
      return (
        <div 
          id={`map-${mapId}`}
          className='w-full h-full rounded-[15px]'
          style={{ height }}
          ref={(el) => {
            if (el && !el.hasChildNodes()) {
              this.initMap(el, coords);
            }
          }}
        />
      );
    }

    return this.renderMapPlaceholder(height);
  }

  renderMapPlaceholder = (height, message = 'Загрузка карты...') => {
    return (
      <div 
        className='w-full h-full rounded-[15px] bg-[#F5F7F9] flex items-center justify-center'
        style={{ height }}
      >
        <div className='text-[#032432]/60'>{message}</div>
      </div>
    );
  }

  initMap = (container, coords) => {
    if (!window.ymaps) return;

    window.ymaps.ready(() => {
      try {
        const map = new window.ymaps.Map(container, {
          center: coords,
          zoom: 16,
          controls: ['zoomControl']
        });

        // Добавляем метку
        const placemark = new window.ymaps.Placemark(
          coords,
          {
            hintContent: 'Наш адрес',
            balloonContent: '606000, Россия, Нижегородская обл., г. Дзержинск, Восточный промрайон Капролактам'
          },
          {
            preset: 'islands#blueDotIcon'
          }
        );
        map.geoObjects.add(placemark);

      } catch (error) {
        console.error('Error initializing map:', error);
      }
    });
  }

  render() {

    const data = this.props?.data || {}

    // Парсим координаты для карты
    const mapCoords = this.parseCoords(data?.mapcoords);

    return (
      <div className='mt-[40px] w-full'>
        <div className='container'>
          <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(data?.h1 || data?.pagetitle)}</div>
          <div className='text-base text-ptgray max-w-[672px] leading-none mt-[12px]'>
            {Parser(data?.introtext || '')}
          </div>
          <div className='mt-[40px] flex-col lg:flex-row flex items-start justify-start gap-[20px] leading-none'>
            <div className='flex-auto w-full lg:w-auto'>
              <div className='w-full flex-col md:flex-row flex items-start justify-start gap-[20px]'>
                <div className='min-h-[157px] flex-auto bg-[#F6F7F8] rounded-[14px] p-[20px] flex flex-col justify-between w-full md:w-auto'>
                  <div className='w-full flex items-start justify-between'>
                    <div className='uppercase text-cardTitle text-ptblack'>Электронная почта</div>
                    <div className='flex-none text-[#001553]'>
                      <EmailIcon width={24} height={24} stroke="currentColor" />
                    </div>
                  </div>
                  <div>
                    {data?.email?.length > 0 ? data.email.map((email, index) => (
                      <>
                        {index > 0 && <br />}
                        <a className='text-base text-ptgray' key={index} href={`mailto:${email}`}>
                          {email}
                        </a>
                      </>
                    )) : ''}
                  </div>
                </div>
                <div style={{ backgroundImage: `url('${data?.fon2}')` }} className='min-h-[157px] bg-cover bg-center flex-none bg-[#001553] rounded-[14px] p-[20px] flex flex-col justify-between w-full md:w-[249px]'>
                  <div className='w-full flex items-start justify-between'>
                    <div className='uppercase text-cardTitle text-white'>Телефоны</div>
                    <div className='flex-none text-white'>
                      <PhoneIcon24 width={24} height={24} stroke="currentColor" />
                    </div>
                  </div>
                  <div>
                    {data?.phone.map( ( phone, k ) => (
                      <>
                        {k > 0 && (
                          <br />
                        )}
                        <a href={`tel:${phone.replace(/[-()\s]/g, '')}`} key={k} className='text-base text-white/60'>{phone}</a>
                      </>
                    ) )}
                  </div>
                </div>
              </div>
              <div style={{ backgroundImage: `url('${data?.fon3}')` }} className='min-h-[142px] mt-[20px] bg-cover bg-center flex-none w-full bg-[#BC0005] rounded-[14px] p-[20px] flex flex-col justify-between'>
                <div className='w-full flex items-start justify-between'>
                  <div className='uppercase text-cardTitle text-white'>Адрес</div>
                  <div className='flex-none text-white'>
                    <LocationIcon24 width={24} height={24} stroke="currentColor" />
                  </div>
                </div>
                <div className='text-base text-white/60'>
                  {Parser(data?.adres || '')}
                </div>
              </div>
            </div>
            <div className='w-full h-[320px] bg-orange-200 rounded-[14px] overflow-hidden lg:hidden'>
              {this.renderMap(mapCoords, '320px', 'contakti-map')}
            </div>
            <div className='w-full lg:w-auto mt-[20px] lg:mt-0'>
              <div className='uppercase text-cardTitle text-ptblack'>Схема проезда</div>
              <div className='bg-[#F6F7F8] p-[10px] rounded-[14px] mt-[20px]'>
                <img src={data?.image} alt='Схема' width={435} height={259} className='h-auto rounded-[8px] mx-auto' />
              </div>
            </div>
          </div>
          <div className='w-full h-[320px] bg-orange-200 rounded-[14px] mt-[20px] overflow-hidden hidden lg:block'>
            {this.renderMap(mapCoords, '320px', 'contakti-map')}
          </div>
          <div className='text-title text-ptblack uppercase tracking-tight mt-[80px] xl:mt-[100px] leading-none'>{Parser(data?.h2 || '')}</div>
          <div className='flex flex-col md:flex-row w-full items-start justify-start gap-[20px] mt-[20px]'>
            {data?.list.map( ( elm ) => {
              return elm.email != '' ? (
                <div className='min-h-[164px] gap-[40px] flex-auto bg-[#F6F7F8] rounded-[14px] p-[20px] flex flex-col justify-between w-full md:w-auto'>
                  <div className='w-full flex items-start justify-between'>
                    <div className='uppercase text-cardTitle text-ptblack'>{elm?.title}</div>
                    <img src={elm?.image} width={42} height={42} alt='br' className='h-auto' />
                  </div>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-[12px]'>
                    <div className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <LocationIcon width={16} height={16} stroke="currentColor" />
                      <div className='text-base text-ptgray'>{elm?.adres}</div>
                    </div>
                    <a href={`tel:${elm?.phone.replace(/[-()\s]/g, '')}`} className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <PhoneIcon width={16} height={16} stroke='currentColor' />
                      <div className='text-base text-ptgray'>{elm?.phone}</div>
                    </a>
                    <a href={`https://www.udarnik.by/`} target='_blank' className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <GlobeIcon width={16} height={16} stroke="currentColor" />
                      <div className='text-base text-ptgray'>{elm?.site}</div>
                    </a>
                    <a href={`mailto:${elm?.email}`} className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <EmailIcon width={16} height={16} stroke="currentColor" />
                      <div className='text-base text-ptgray'>{elm?.email}</div>
                    </a>
                  </div>
                </div>
              ) : (
                <div className='min-h-[164px] gap-[40px] flex-none w-full md:w-[442px] bg-[#F6F7F8] rounded-[14px] p-[20px] flex flex-col justify-between'>
                  <div className='w-full flex items-start justify-between'>
                    <div className='uppercase text-cardTitle text-ptblack'>{elm?.title}</div>
                    <img src={elm?.image} width={42} height={42} alt='kz' className='h-auto' />
                  </div>
                  <div className='grid grid-cols-1 gap-[12px]'>
                    <div className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <LocationIcon width={16} height={16} stroke='currentColor' />
                      <div className='text-base text-ptgray'>{elm?.adres}</div>
                    </div>
                    <a href={`tel:${elm?.phone.replace(/[-()\s]/g, '')}`} className='flex items-center justify-start gap-[8px] text-ptblack'>
                      <PhoneIcon width={16} height={16} stroke='currentColor' />
                      <div className='text-base text-ptgray'>{elm?.phone}</div>
                    </a>
                  </div>
                </div>
              )
            } )}
          </div>
        </div>
      </div>
    )
  }
}

export default First;